import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { UpdatesActions } from './updates.actions';
import { UpdatesSelectors } from './updates.selectors';

@Injectable({ providedIn: 'root' })
export class UpdatesStore {
  state$ = this.store.select(UpdatesSelectors.selectState);
  loading$ = this.store.select(UpdatesSelectors.selectSLoadingIndicator);
  viGuideUpdates$ = this.store.select(UpdatesSelectors.selectViGuideUpdates);
  viCareAndroidUpdates$ = this.store.select(UpdatesSelectors.selectViCareAndroidUpdates);
  viCareIOSUpdates$ = this.store.select(UpdatesSelectors.selectViCareIOSUpdates);
  updatesAmount$ = this.store.select(UpdatesSelectors.selectUpdatesAmount);

  constructor(private store: Store) {}

  fetchViGuideUpdates(): void {
    this.store.dispatch(UpdatesActions.getViGuideUpdates());
  }

  fetchViCareUpdates(): void {
    this.store.dispatch(UpdatesActions.getViCareUpdates());
  }
}
